var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{attrs:{"id":"master_app"}},[_c('v-app',{attrs:{"id":"app"}},[_c('project-list-details',{attrs:{"projects":_vm.projects,"project_type":_vm.project_type,"settings":_vm.settings}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }